import { configureStore } from "@reduxjs/toolkit";
import typeSlice from "./slices/typeSlice";
import modelSlice from "./slices/modelSlice";
import userSlice from "./slices/userSlice";
import conversationSlice from "./slices/conversationSlice";
import errorSlice from "./slices/errorSlice";
import settingModalSlice from "./slices/settingSlice";
import loadingSlice from "./slices/loadingSlice";
import dashboardSlice from "./slices/dashboardSlice";
import showSourcesSlice from "./slices/showSourcesSlice";
import drawerOpeningSlice from "./slices/drawerOpening";
import collectionSlice from "./slices/collectionSlice";
import feedbackSlice from "./slices/feedbackSlice";
// ...

export const store = configureStore({
  reducer: {
    type: typeSlice,
    model: modelSlice,
    user: userSlice,
    conversation: conversationSlice,
    error: errorSlice,
    settingModal: settingModalSlice,
    loading: loadingSlice,
    dashboard: dashboardSlice,
    showSources: showSourcesSlice,
    drawerOpening: drawerOpeningSlice,
    collection: collectionSlice,
    feedback: feedbackSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
